<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>交易管理</el-breadcrumb-item>
        <el-breadcrumb-item>交易查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form ref="listParamsForm" :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="订单编号：" prop="orderNo">
              <el-input style="width: 100%" size="small" v-model="listParams.orderNo"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="订单状态：" prop="orderStatus">
              <el-select clearable style="width: 100%" size="small" v-model="listParams.orderStatus">
                <el-option v-for="item in orderStatusList" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="支付方式：" prop="paymentType">
              <el-select clearable style="width: 100%" size="small" v-model="listParams.paymentType">
                <el-option v-for="item in payWayList" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="供应点：" prop="siteId">
              <el-select size="small" v-model="listParams.siteId" placeholder="请选择供应点" style="width: 100%">
                <el-option v-for="(item, index) in logisticsSiteIdList" :key="index" :value="item.id" :label="item.title"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="电话号码：" prop="buyerMobile">
              <el-input size="small" v-model="listParams.buyerMobile" placeholder="请输入电话号码" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="保障级别：" prop="supplyLevelId">
              <el-select style="width: 100%" v-model="listParams.supplyLevelId" size="small" placeholder="请选择保障级别" clearable>
                <el-option v-for="item in levelList" :label="item.levelName" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="领货日期：" prop="timeInterval">
              <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData">查询</el-button>

              <el-button style="margin-left: 20px" size="small" @click="resetForm('listParamsForm')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" @expand-change="load" ref="table" :data="tableData" border>
        <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <el-table v-loading="goodLoading" :data="row.goodData" border>
              <el-table-column align="center" prop="productTitle" label="商品名称" />
              <el-table-column align="center" prop="productSpec" label="商品规格" />
              <el-table-column align="center" prop="productQuantity" label="商品数量" />
              <el-table-column align="center" prop="productPrice" label="商品销售价" />
              <el-table-column align="center" prop="subTotal" label="商品定金" />
              <el-table-column align="center" prop="subTotal" label="折扣优惠" />
              <el-table-column align="center" prop="tradeAmountTotal" label="商品核销金额" />
            </el-table>
          </template>
        </el-table-column>

        <el-table-column width="120" prop="orderNo" align="center" label="订单编号">
          <template slot-scope="scope">
            <div v-if="scope.row.orderNo">
              <div v-if="scope.row.orderNo.length > 10">
                <el-popover ref="popover1" placement="top-start" width="200" trigger="hover" :content="scope.row.orderNo"></el-popover>
                <el-button style="color: #606266" type="text" v-popover:popover1>{{ scope.row.orderNo | formatLimitLength }}</el-button>
              </div>
              <div v-else>{{ scope.row.orderNo }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="120" prop="buyerMobile" align="center" label="买家信息" />
        <el-table-column prop="orderAmount" align="center" label="商品总价" />
        <el-table-column prop="levelDiscountAmount" align="center" label="折扣金额" />
        <el-table-column prop="paymentAmount" align="center" label="支付金额" />
        <el-table-column prop="amountTotal" align="center" label="商品核销总额" />
        <el-table-column align="center" label="补差/退款">
          <template slot-scope="{ row }">
            {{ (row.paymentAmount * 1000 - row.amountTotal * 1000) / 1000 }}
          </template>
        </el-table-column>

        <el-table-column prop="supplyDate" align="center" width="200" label="领货日期" />

        <el-table-column prop="orderStatusDisplay" align="center" label="订单状态" />

        <el-table-column prop="paymentType" align="center" label="支付方式" />

        <el-table-column prop="logisticsSiteName" align="center" label="供应点" />

        <el-table-column prop="supplyLevelName" align="center" label="级别名称" />

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="linkToDetailPage(scope.row.orderId)"> 详情 </el-button>

            <el-button v-if="[7].includes(scope.row.orderStatus)" type="text" @click="handleRefund(scope.row)"> 退款 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <DialogRefund :dialogVisible.sync="dialogVisibleRefund" :orderItem="refundItem" @success="loadTableData" />
  </div>
</template>

<script>
import DialogRefund from "./components/DialogRefund";
import { featchOderdetail } from "./api";
export default {
  components: { DialogRefund },

  data() {
    return {
      listParams: {
        supplyId: "",
        orderNo: "",
        orderStatus: "",
        paymentType: "",
        timeInterval: ["", ""],
        siteId: "",
        buyerMobile: "",
        supplyLevelId: "",
      },
      logisticsSiteIdList: [],
      levelList: [],
      orderStatusList: [
        { label: "全部", value: "" },
        { label: "已取消", value: "0" },
        { label: "待付款", value: "1" },
        { label: "待发货", value: "2" },
        { label: "待收货", value: "3" },
        { label: "待补差", value: "4" },
        { label: "待退款", value: "5" },
        { label: "退款中", value: "6" },
        { label: "已完成", value: "7" },
        { label: "交易关闭", value: "8" },
      ],
      payWayList: [
        { label: "全部", value: "" },
        { label: "支付宝支付", value: "alipay" },
        { label: "微信支付", value: "wechatpay" },
        { label: "银联支付", value: "unionpay" },
        { label: "建行支付宝", value: "ccbpay_alipay" },
        { label: "建行微信支付", value: "ccbpay_wechatpay" },
        { label: "建行龙卡支付", value: "ccbpay_drogonpay" },
      ],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      levelPager: {
        pageIndex: 1,
        pageSize: 99,
      },
      dialogVisibleRefund: false,
      refundItem: {},
      goodData: [],
      goodLoading: false,
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.loadTableData();
    this.loadLogisticsSiteIdList();
    this.loadLevelList();
  },
  methods: {
    /**
     * 懒加载商品列表
     */
    load(tree) {
      this.goodLoading = true;
      featchOderdetail(this, { orderId: tree.orderId })
        .then(res => {
          tree.goodData = res;
          this.goodLoading = false;
        })
        .catch(error => {
          console.err(error);
          this.goodLoading = false;
        });
    },
    /**
     * 初始化供应点列表
     */
    loadLogisticsSiteIdList() {
      this.$http({
        url: global.apiUrl + "/logistics/index",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.logisticsSiteIdList = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载保障级别列表
     */
    loadLevelList() {
      this.$http({
        url: global.apiUrl + "/supply/level",
        methods: "GET",
        params: {
          supplyId: this.listParams.supplyId,
          pageIndex: this.levelPager.pageIndex,
          pageSize: this.levelPager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.levelList = res.body.data.data;
            } else {
              this.levelList = [];
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      });
      bodyParams.supplyStartDate = bodyParams.timeInterval[0];
      bodyParams.supplyEndDate = bodyParams.timeInterval[1];
      delete bodyParams.timeInterval;
      for (const i in bodyParams) {
        if (bodyParams[i] === "" || bodyParams[i] === undefined) {
          delete bodyParams[i];
        }
      }
      this.$http({
        url: global.apiUrl + "/order/list",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.orderList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * 导出交易查询列表EXCEL
     */
    exportExcel() {},
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 跳转至详情页
     * @param orderId
     */
    linkToDetailPage(orderId) {
      this.$router.push({
        name: "tradeInquireDetail",
        query: {
          id: orderId,
        },
      });
    },
    /**
     * 处理退款
     */
    handleRefund(data) {
      this.dialogVisibleRefund = true;
      this.refundItem = data;
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
